export enum VersionChangeType {
    APPROVER = 'approval',
    CHANNELS = 'channels',
    MIMICS = 'mimics',
    CHANNEL_OVERVIEW = 'channelOverview',
    CHANNEL_GROUP = 'channelGroups',
    CATEGORY = 'categories',
    OPS = 'numberOps',
    FCU = 'numberFcu',
    Owner = 'owner',
    CREATED = 'folderCreated',
}

export const COLOR_OPTIONS = [
    '#fc78a8',
    '#a29bfe',
    '#6c5de7',
    '#4fa8de',
    '#57cee1',
    '#56ebc1',
    '#fc78a8',
    '#a29bfe',
    '#6c5de7',
    '#4fa8de',
    '#57cee1',
    '#fc78a8',
    '#a29bfe',
    '#6c5de7',
    '#4fa8de',
    '#57cee1',
];
